module.exports = __webpack_public_path__ + "img/Motor_fre_1.2d381f8c.jpg";